import * as React from "react";

//icon
import { faSpinnerThird } from "@performyard/fontawesome/pro-regular-svg-icons";

import { cn } from "../../../lib/utils";

//sub components
import { Icon, IconProps } from "../Icon";
//styles for animation
import "./spinner.css";

export type SpinnerProps = {
	/**
	 * The color of the spinner, uses IconProps["color"]
	 */
	color?: IconProps["color"];
	/**
	 * The size of the spinner, uses IconProps["size"]
	 */
	size?: IconProps["size"];
	/**
	 * A className to be applied to the spinner.
	 */
	dangerouslySetClassName?: string;
};

/**
 * A Spinner component that displays a loading spinner
 */
export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(function Spinner(
	props: SpinnerProps,
	ref: React.Ref<HTMLDivElement>
) {
	const { color = "primary-5", size = 16, dangerouslySetClassName } = props;

	return (
		<div className="aspect-square w-fit rounded-full">
			<Icon
				dangerouslySetClassName={cn("spinner rounded-full", dangerouslySetClassName)}
				color={color}
				size={size}
				icon={faSpinnerThird}
				ref={ref}
			/>
		</div>
	);
});

Spinner.displayName = "Spinner";
